/**
 * confirm関数のような処理をダイアログメッセージで実装できます。
 *
 * Updated: 2023/09/29
 *
 * @param {Object} options
 * @param {String} options.type success、info、warning、error の４タイプを指定可能
 * @param {String} options.title モーダルウィンドウのタイトル
 * @param {String} options.content モーダルウィンドウのコンテンツ（HTML）
 * @param {String} options.okButtonLabel OKボタンのラベル
 * @param {String} options.cancelButtonLabel キャンセルボタンのラベル
 * @param {Function} options.callback OKボタンがクリックされたときに実行される関数
 */
export function modalConfirm(options) {
    const defaultOptions = {
        type: '',
        title: '確認',
        content: 'よろしいですか？',
        okButtonLabel: 'OK',
        cancelButtonLabel: 'キャンセル',
        callback: function () {}
    };

    const op = { ...defaultOptions, ...options };

    if (op.type && mtappIcons[op.type]) {
        op.title = `<svg role="img" class="mt-icon--${op.type} mt-icon--sm">${mtappIcons[op.type]}</svg> ${op.title}`;
    }

    const modalHTML = `
        <div id="mtapp-modal-confirm" class="modal fade" role="dialog" aria-labelledby="mtapp-modal-confirm-title" data-backdrop="static">
            <div id="mtapp-modal-confirm-dialog" class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 id="mtapp-modal-confirm-title" class="modal-title">${op.title}</h4>
                    </div>
                    <div id="mtapp-modal-confirm-content" class="modal-body">${op.content}</div>
                    <div class="modal-footer">
                        <a data-dismiss="modal" class="modal-cancel" data-bs-dismiss="modal">${op.cancelButtonLabel}</a>
                        <button id="mtapp-modal-confirm-submit" type="button" class="btn btn-primary">${op.okButtonLabel}</button>
                    </div>
                </div>
            </div>
        </div>`;

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    const modalElement = document.getElementById('mtapp-modal-confirm');
    modalElement.setAttribute('data-mtapp-type', op.type);

    // 最後にフォーカスされた要素を記録
    let lastFocusedElement = document.activeElement;

    const submitBtn = document.getElementById('mtapp-modal-confirm-submit');

    submitBtn.addEventListener('click', () => {
        const bsModal = bootstrap.Modal.getInstance(modalElement);
        bsModal.hide();
        op.callback();
    });

    const bsModal = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false,
        focus: true
    });

    bsModal.show();

    // モーダルが閉じる前にフォーカスを戻す
    modalElement.addEventListener('hide.bs.modal', () => {
        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function' && document.contains(lastFocusedElement)) {
            lastFocusedElement.focus(); // 元の要素がまだ存在する場合のみフォーカスを戻す
        } else {
            // フォーカスを戻す要素がない場合は特定の要素からフォーカスを外す
            document.body.focus();
        }
        document.body.removeChild(modalElement);
    });
}
